import { combineReducers } from 'redux';

import {
  appReducer,
  userReducer,
  transactionsReducer,
  lumiaReducer,
  governanceReducer,
  poolsReducer,
  debugReducer,
} from './slices';

export const rootReducer = combineReducers({
  app: appReducer,
  governance: governanceReducer,
  user: userReducer,
  transactions: transactionsReducer,
  lumia: lumiaReducer,
  pools: poolsReducer,
  debug: debugReducer,
});
